// This file is auto-generated by @hey-api/openapi-ts
import { client } from "./client.gen";
/**
 * Get municipalities
 *
 * **Allowed Permissions:** `municipalities:read:global`
 */
export const getMunicipalities = (options) => (options?.client ?? client).get({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/municipalities",
    ...options,
});
/**
 * Create municipality. `dataSources` lists the adapters to switch on beyond the built-in ones (category defaults, OpenStreetMap, manual corrections), each as a (source, kind) pair with a rank; rank 1 is consulted first among them.
 *
 * **Allowed Permissions:** `municipalities:create:global`
 */
export const postMunicipalities = (options) => (options?.client ?? client).post({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/municipalities",
    ...options,
    headers: {
        "Content-Type": "application/json",
        ...options?.headers,
    },
});
/**
 * Delete municipality
 *
 * **Allowed Permissions:** `municipalities:delete:global`
 */
export const deleteMunicipalitiesByMunicipalityId = (options) => (options.client ?? client).delete({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/municipalities/{municipalityId}",
    ...options,
});
/**
 * Get municipality
 *
 * **Allowed Permissions:** `municipalities:read:global`
 */
export const getMunicipalitiesByMunicipalityId = (options) => (options.client ?? client).get({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/municipalities/{municipalityId}",
    ...options,
});
/**
 * Rename a municipality or move it to another configured country. Only the fields given change; the country's settings apply from its next import.
 *
 * **Allowed Permissions:** `municipalities:update:global`
 */
export const patchMunicipalitiesByMunicipalityId = (options) => (options.client ?? client).patch({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/municipalities/{municipalityId}",
    ...options,
    headers: {
        "Content-Type": "application/json",
        ...options.headers,
    },
});
/**
 * Get the adapters a municipality has switched on, by kind and rank. The built-in adapters are not listed because they cannot be switched off.
 *
 * **Allowed Permissions:** `municipalities:read:global`
 */
export const getMunicipalitiesByMunicipalityIdDataSources = (options) => (options.client ?? client).get({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/municipalities/{municipalityId}/data-sources",
    ...options,
});
/**
 * Replace the adapters a municipality has switched on for one kind of data. The list is complete for that kind: an adapter of it not in the list is switched off. Adapters of the other kinds are left alone. Every row must name the kind in the path. Takes effect on the next import of that kind.
 *
 * **Allowed Permissions:** `municipalities:update:global`
 */
export const putMunicipalitiesByMunicipalityIdDataSourcesByKind = (options) => (options.client ?? client).put({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/municipalities/{municipalityId}/data-sources/{kind}",
    ...options,
    headers: {
        "Content-Type": "application/json",
        ...options.headers,
    },
});
/**
 * Delete geo fence
 *
 * **Allowed Permissions:** `geo-fences:delete:global`
 */
export const deleteMunicipalitiesByMunicipalityIdGeoFence = (options) => (options.client ?? client).delete({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/municipalities/{municipalityId}/geo-fence",
    ...options,
});
/**
 * Get geo fence
 *
 * **Allowed Permissions:** `geo-fences:read:global`
 */
export const getMunicipalitiesByMunicipalityIdGeoFence = (options) => (options.client ?? client).get({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/municipalities/{municipalityId}/geo-fence",
    ...options,
});
/**
 * Create or replace geo fence
 *
 * **Allowed Permissions:** `geo-fences:create:global`, `geo-fences:update:global`
 */
export const putMunicipalitiesByMunicipalityIdGeoFence = (options) => (options.client ?? client).put({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/municipalities/{municipalityId}/geo-fence",
    ...options,
    headers: {
        "Content-Type": "application/json",
        ...options.headers,
    },
});
/**
 * List the corrections an operator has made to the places on the municipality geo fence: places added by hand, and feed places taken out of use. Responds 404 without a fence.
 *
 * **Allowed Permissions:** `points-of-interest:read:global`
 */
export const getMunicipalitiesByMunicipalityIdPointOfInterestCorrections = (options) => (options.client ?? client).get({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/municipalities/{municipalityId}/point-of-interest-corrections",
    ...options,
});
/**
 * Store a correction. An add carries a point inside the geo fence and the category it belongs to; a suppress names a feed and that feed’s own id for the place to take out. Either takes effect on the next read of the places endpoint, without an import. Responds 400 for a point outside the fence and 409 if the same place is already suppressed.
 *
 * **Allowed Permissions:** `points-of-interest:import:global`
 */
export const postMunicipalitiesByMunicipalityIdPointOfInterestCorrections = (options) => (options.client ?? client).post({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/municipalities/{municipalityId}/point-of-interest-corrections",
    ...options,
    headers: {
        "Content-Type": "application/json",
        ...options.headers,
    },
});
/**
 * Delete a correction: removing an add takes the hand-placed place off the map, and removing a suppress puts the feed’s place back. Both take effect immediately.
 *
 * **Allowed Permissions:** `points-of-interest:import:global`
 */
export const deleteMunicipalitiesByMunicipalityIdPointOfInterestCorrectionsByCorrectionId = (options) => (options.client ?? client).delete({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/municipalities/{municipalityId}/point-of-interest-corrections/{correctionId}",
    ...options,
});
/**
 * Queue a points of interest import for the municipality geo fence: fetches the places the enabled feed knows of around the fence, keeps the ones inside it and replaces what that feed stored before. Responds 409 while any import for the same fence is queued or running, and 409 when the municipality has no places feed enabled.
 *
 * **Allowed Permissions:** `points-of-interest:import:global`
 */
export const postMunicipalitiesByMunicipalityIdPointsOfInterestJobs = (options) => (options.client ?? client).post({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/municipalities/{municipalityId}/points-of-interest/jobs",
    ...options,
});
/**
 * Get the most recent places import with its steps and the feed it was planned with. Responds 404 if none has ever run.
 *
 * **Allowed Permissions:** `points-of-interest:read:global`
 */
export const getMunicipalitiesByMunicipalityIdPointsOfInterestJobsLatest = (options) => (options.client ?? client).get({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/municipalities/{municipalityId}/points-of-interest/jobs/latest",
    ...options,
});
/**
 * Ask a queued or running places import to stop. A running import stops at its next stage boundary. Responds 409 if the import has already finished.
 *
 * **Allowed Permissions:** `points-of-interest:import:global`
 */
export const postMunicipalitiesByMunicipalityIdPointsOfInterestJobsByJobIdCancel = (options) => (options.client ?? client).post({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/municipalities/{municipalityId}/points-of-interest/jobs/{jobId}/cancel",
    ...options,
});
/**
 * Get places import log events newer than a cursor, oldest first
 *
 * **Allowed Permissions:** `points-of-interest:read:global`
 */
export const getMunicipalitiesByMunicipalityIdPointsOfInterestJobsByJobIdEvents = (options) => (options.client ?? client).get({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/municipalities/{municipalityId}/points-of-interest/jobs/{jobId}/events",
    ...options,
});
/**
 * Get the places in use inside the municipality geo fence: the enabled feed’s rows, each flagged with whether a correction has taken it out of use, plus the places added by hand. Unpaginated by design: this is what the map layer draws, and a partly drawn map is worse than none. An empty list is the honest answer for a municipality with no feed enabled.
 *
 * **Allowed Permissions:** `points-of-interest:read:global`
 */
export const getMunicipalitiesByMunicipalityIdPointsOfInterest = (options) => (options.client ?? client).get({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/municipalities/{municipalityId}/points-of-interest",
    ...options,
});
/**
 * Queue a population import for the municipality geo fence: fetches the residence grid the enabled feed publishes around the fence, works out how much of each cell lies inside it and replaces what that feed stored before. Responds 409 while any import for the same fence is queued or running, and 409 when the municipality has no population feed enabled.
 *
 * **Allowed Permissions:** `population:import:global`
 */
export const postMunicipalitiesByMunicipalityIdPopulationJobs = (options) => (options.client ?? client).post({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/municipalities/{municipalityId}/population/jobs",
    ...options,
});
/**
 * Get the most recent population import with its steps and the feed it was planned with. Responds 404 if none has ever run.
 *
 * **Allowed Permissions:** `population:read:global`
 */
export const getMunicipalitiesByMunicipalityIdPopulationJobsLatest = (options) => (options.client ?? client).get({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/municipalities/{municipalityId}/population/jobs/latest",
    ...options,
});
/**
 * Ask a queued or running population import to stop. A running import stops at its next stage boundary. Responds 409 if the import has already finished.
 *
 * **Allowed Permissions:** `population:import:global`
 */
export const postMunicipalitiesByMunicipalityIdPopulationJobsByJobIdCancel = (options) => (options.client ?? client).post({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/municipalities/{municipalityId}/population/jobs/{jobId}/cancel",
    ...options,
});
/**
 * Get population import log events newer than a cursor, oldest first
 *
 * **Allowed Permissions:** `population:read:global`
 */
export const getMunicipalitiesByMunicipalityIdPopulationJobsByJobIdEvents = (options) => (options.client ?? client).get({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/municipalities/{municipalityId}/population/jobs/{jobId}/events",
    ...options,
});
/**
 * Get the population grid cells stored for the municipality geo fence, the ones around it included: a catchment that crosses the boundary needs its neighbours, and `overlapFraction` tells the two apart — 0 marks a context cell outside the fence. Unpaginated by design: this is what the heat map draws and what the models weight, and a partly drawn grid is worse than none. An empty list is the honest answer for a municipality with no feed enabled.
 *
 * **Allowed Permissions:** `population:read:global`
 */
export const getMunicipalitiesByMunicipalityIdPopulationCells = (options) => (options.client ?? client).get({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/municipalities/{municipalityId}/population/cells",
    ...options,
});
/**
 * Queue a land use import for the municipality geo fence: fetches the areas the enabled feed has mapped around the fence, clips them to it, settles where they overlap and replaces what that feed stored before. Responds 409 while any import for the same fence is queued or running, and 409 when the municipality has no land use feed enabled.
 *
 * **Allowed Permissions:** `land-use-zones:import:global`
 */
export const postMunicipalitiesByMunicipalityIdLandUseZonesJobs = (options) => (options.client ?? client).post({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/municipalities/{municipalityId}/land-use-zones/jobs",
    ...options,
});
/**
 * Get the most recent land use import with its steps and the feed it was planned with. Responds 404 if none has ever run.
 *
 * **Allowed Permissions:** `land-use-zones:read:global`
 */
export const getMunicipalitiesByMunicipalityIdLandUseZonesJobsLatest = (options) => (options.client ?? client).get({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/municipalities/{municipalityId}/land-use-zones/jobs/latest",
    ...options,
});
/**
 * Ask a queued or running land use import to stop. A running import stops at its next stage boundary. Responds 409 if the import has already finished.
 *
 * **Allowed Permissions:** `land-use-zones:import:global`
 */
export const postMunicipalitiesByMunicipalityIdLandUseZonesJobsByJobIdCancel = (options) => (options.client ?? client).post({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/municipalities/{municipalityId}/land-use-zones/jobs/{jobId}/cancel",
    ...options,
});
/**
 * Get land use import log events newer than a cursor, oldest first
 *
 * **Allowed Permissions:** `land-use-zones:read:global`
 */
export const getMunicipalitiesByMunicipalityIdLandUseZonesJobsByJobIdEvents = (options) => (options.client ?? client).get({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/municipalities/{municipalityId}/land-use-zones/jobs/{jobId}/events",
    ...options,
});
/**
 * Get the land use zones stored for the municipality geo fence, clipped to it. One feed’s zones do not overlap, so their areas add up to the ground they cover. Unpaginated by design: this is what the map draws and what the models read, and a partly drawn map reads as land with no use. An empty list is the honest answer for a municipality with no feed enabled.
 *
 * **Allowed Permissions:** `land-use-zones:read:global`
 */
export const getMunicipalitiesByMunicipalityIdLandUseZones = (options) => (options.client ?? client).get({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/municipalities/{municipalityId}/land-use-zones",
    ...options,
});
/**
 * Queue a buildings import for the municipality geo fence: reads the footprints the enabled base publishes around the fence, keeps each building whole, fills what the source leaves out from per-use defaults and shares each population cell over the buildings in it. Responds 409 while any import for the same fence is queued or running, and 409 when the municipality has no buildings feed enabled.
 *
 * **Allowed Permissions:** `buildings:import:global`
 */
export const postMunicipalitiesByMunicipalityIdBuildingsJobs = (options) => (options.client ?? client).post({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/municipalities/{municipalityId}/buildings/jobs",
    ...options,
});
/**
 * Get the most recent buildings import with its steps, the base it was planned with and, once it has finished, its quality report. Responds 404 if none has ever run.
 *
 * **Allowed Permissions:** `buildings:read:global`
 */
export const getMunicipalitiesByMunicipalityIdBuildingsJobsLatest = (options) => (options.client ?? client).get({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/municipalities/{municipalityId}/buildings/jobs/latest",
    ...options,
});
/**
 * Ask a queued or running buildings import to stop. A running import stops at its next stage boundary. Responds 409 if the import has already finished.
 *
 * **Allowed Permissions:** `buildings:import:global`
 */
export const postMunicipalitiesByMunicipalityIdBuildingsJobsByJobIdCancel = (options) => (options.client ?? client).post({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/municipalities/{municipalityId}/buildings/jobs/{jobId}/cancel",
    ...options,
});
/**
 * Get buildings import log events newer than a cursor, oldest first
 *
 * **Allowed Permissions:** `buildings:read:global`
 */
export const getMunicipalitiesByMunicipalityIdBuildingsJobsByJobIdEvents = (options) => (options.client ?? client).get({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/municipalities/{municipalityId}/buildings/jobs/{jobId}/events",
    ...options,
});
/**
 * Get the buildings the enabled base stored for the municipality geo fence, one row per building with its whole MultiPolygon footprint, its resolved values, where each came from, and its residents. Buildings around the fence come too, so a population cell on the edge reads whole; `inFence` tells them apart, and only the fence’s own carry residents. `residentsEstimate` is null when the population was re-imported after the estimate: re-import the buildings to refresh it. Every use and stage is stored; pass `uses` and `stages` to narrow, such as `stages=existing`. Unpaginated by design, like the population grid: the map and the models read the fence whole. An empty list is the honest answer for a municipality with no buildings feed enabled.
 *
 * **Allowed Permissions:** `buildings:read:global`
 */
export const getMunicipalitiesByMunicipalityIdBuildings = (options) => (options.client ?? client).get({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/municipalities/{municipalityId}/buildings",
    ...options,
});
/**
 * List the manual corrections drawn inside the municipality geo fence: lines an operator placed over a stretch of road with the attribute values they assert for it. Responds 404 without a fence.
 *
 * **Allowed Permissions:** `road-segments:read:global`
 */
export const getMunicipalitiesByMunicipalityIdRoadSegmentAttributeCorrections = (options) => (options.client ?? client).get({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/municipalities/{municipalityId}/road-segment-attribute-corrections",
    ...options,
});
/**
 * Store a manual correction: a line along a stretch of road and at least one attribute value for it. A name needs a name kind. The correction is applied by the manual adapter on the next attributes import, where it wins over every other source for the segments the line covers.
 *
 * **Allowed Permissions:** `road-segment-attributes:import:global`
 */
export const postMunicipalitiesByMunicipalityIdRoadSegmentAttributeCorrections = (options) => (options.client ?? client).post({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/municipalities/{municipalityId}/road-segment-attribute-corrections",
    ...options,
    headers: {
        "Content-Type": "application/json",
        ...options.headers,
    },
});
/**
 * Delete a correction. Observations it produced stay until the next attributes import re-runs the manual adapter.
 *
 * **Allowed Permissions:** `road-segment-attributes:import:global`
 */
export const deleteMunicipalitiesByMunicipalityIdRoadSegmentAttributeCorrectionsByCorrectionId = (options) => (options.client ?? client).delete({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/municipalities/{municipalityId}/road-segment-attribute-corrections/{correctionId}",
    ...options,
});
/**
 * Queue a road segment attributes import for the municipality geo fence. Runs every attribute adapter in the municipality’s run order (category defaults, OpenStreetMap, the configured adapters by rank, manual corrections), then resolves one value per attribute and names the intersections. Requires a road network; run the road segments import first. Responds 409 while any import for the same fence is queued or running.
 *
 * **Allowed Permissions:** `road-segment-attributes:import:global`
 */
export const postMunicipalitiesByMunicipalityIdRoadSegmentAttributesJobs = (options) => (options.client ?? client).post({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/municipalities/{municipalityId}/road-segment-attributes/jobs",
    ...options,
});
/**
 * Get the most recent attributes import with its steps and the adapter run order it was planned with. Responds 404 if none has ever run.
 *
 * **Allowed Permissions:** `road-segments:read:global`
 */
export const getMunicipalitiesByMunicipalityIdRoadSegmentAttributesJobsLatest = (options) => (options.client ?? client).get({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/municipalities/{municipalityId}/road-segment-attributes/jobs/latest",
    ...options,
});
/**
 * Ask a queued or running attributes import to stop. A running import stops at its next stage boundary. Responds 409 if the import has already finished.
 *
 * **Allowed Permissions:** `road-segment-attributes:import:global`
 */
export const postMunicipalitiesByMunicipalityIdRoadSegmentAttributesJobsByJobIdCancel = (options) => (options.client ?? client).post({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/municipalities/{municipalityId}/road-segment-attributes/jobs/{jobId}/cancel",
    ...options,
});
/**
 * Get attributes import log events newer than a cursor, oldest first
 *
 * **Allowed Permissions:** `road-segments:read:global`
 */
export const getMunicipalitiesByMunicipalityIdRoadSegmentAttributesJobsByJobIdEvents = (options) => (options.client ?? client).get({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/municipalities/{municipalityId}/road-segment-attributes/jobs/{jobId}/events",
    ...options,
});
/**
 * Queue a road segments (topology) import for the municipality geo fence: fetches OpenStreetMap, builds the segments and intersections and links them. Replaces the network, which also clears every attribute observation on it; run the attributes import afterwards. Responds 409 while any import for the same fence is queued or running.
 *
 * **Allowed Permissions:** `road-segments:import:global`
 */
export const postMunicipalitiesByMunicipalityIdRoadSegmentsJobs = (options) => (options.client ?? client).post({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/municipalities/{municipalityId}/road-segments/jobs",
    ...options,
});
/**
 * Get the most recent road segments import with its steps. Responds 404 if none has ever run.
 *
 * **Allowed Permissions:** `road-segments:read:global`
 */
export const getMunicipalitiesByMunicipalityIdRoadSegmentsJobsLatest = (options) => (options.client ?? client).get({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/municipalities/{municipalityId}/road-segments/jobs/latest",
    ...options,
});
/**
 * Ask a queued or running import to stop. A running import stops at its next stage boundary. Responds 409 if the import has already finished.
 *
 * **Allowed Permissions:** `road-segments:import:global`
 */
export const postMunicipalitiesByMunicipalityIdRoadSegmentsJobsByJobIdCancel = (options) => (options.client ?? client).post({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/municipalities/{municipalityId}/road-segments/jobs/{jobId}/cancel",
    ...options,
});
/**
 * Get import log events newer than a cursor, oldest first
 *
 * **Allowed Permissions:** `road-segments:read:global`
 */
export const getMunicipalitiesByMunicipalityIdRoadSegmentsJobsByJobIdEvents = (options) => (options.client ?? client).get({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/municipalities/{municipalityId}/road-segments/jobs/{jobId}/events",
    ...options,
});
/**
 * Get road segment and junction counts for the stored network
 *
 * **Allowed Permissions:** `road-segments:read:global`
 */
export const getMunicipalitiesByMunicipalityIdRoadSegmentsSummary = (options) => (options.client ?? client).get({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/municipalities/{municipalityId}/road-segments/summary",
    ...options,
});
/**
 * Get every road segment and junction of the stored network. Unpaginated by design: a partly drawn map is worse than none, and this is what the map layer consumes. Pass excludeCategories=service to leave out minor access roads — back lanes, courtyard and delivery entrances, driveways, parking aisles. Their share swings with how suburban the area is, from 38% of length in a town of detached houses to under 8% in a dense city centre; junctions left with no segment are dropped with them.
 *
 * **Allowed Permissions:** `road-segments:read:global`
 */
export const getMunicipalitiesByMunicipalityIdRoadSegments = (options) => (options.client ?? client).get({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/municipalities/{municipalityId}/road-segments",
    ...options,
});
/**
 * Get current user information
 */
export const getUsersMe = (options) => (options?.client ?? client).get({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/users/me",
    ...options,
});
/**
 * List every user, global and municipality ones, with their role. Paged, sorted and filtered by the query; `email[ilike]=…` searches by email.
 *
 * **Allowed Permissions:** `users:read:global`
 */
export const getUsers = (options) => (options?.client ?? client).get({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/users",
    ...options,
});
/**
 * Change a user's role, to one whose permissions you hold yourself, or deactivate them. A deactivated user can't sign in, and their sessions stop working. You cannot change your own user.
 *
 * **Allowed Permissions:** `users:update:global`
 */
export const patchUsersByUserId = (options) => (options.client ?? client).patch({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/users/{userId}",
    ...options,
    headers: {
        "Content-Type": "application/json",
        ...options.headers,
    },
});
/**
 * Log in with email and password; the session is set in cookies
 */
export const postAuthLogin = (options) => (options?.client ?? client).post({
    url: "/auth/login",
    ...options,
    headers: {
        "Content-Type": "application/json",
        ...options?.headers,
    },
});
/**
 * Log out and revoke the current session
 */
export const postAuthLogout = (options) => (options?.client ?? client).post({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/auth/logout",
    ...options,
});
/**
 * Set a password with the token from an invite email; signs out other sessions
 */
export const postAuthPassword = (options) => (options?.client ?? client).post({
    url: "/auth/password",
    ...options,
    headers: {
        "Content-Type": "application/json",
        ...options?.headers,
    },
});
/**
 * List the permission catalogue, paged, sorted and filtered (by `scope`, or `action`).
 *
 * **Allowed Permissions:** `permissions:read:global`
 */
export const getPermissions = (options) => (options?.client ?? client).get({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/permissions",
    ...options,
});
/**
 * List the permissions a municipality may use: the ceiling for its roles. Its own users can read it to build roles from.
 *
 * **Allowed Permissions:** `permissions:read:global`, `permissions:read:municipality`
 */
export const getMunicipalitiesByMunicipalityIdPermissions = (options) => (options.client ?? client).get({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/municipalities/{municipalityId}/permissions",
    ...options,
});
/**
 * Replace the permissions a municipality may use. Only municipality permissions are accepted. A permission left out is also taken off every role in the municipality.
 *
 * **Allowed Permissions:** `permissions:update:global`
 */
export const putMunicipalitiesByMunicipalityIdPermissions = (options) => (options.client ?? client).put({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/municipalities/{municipalityId}/permissions",
    ...options,
    headers: {
        "Content-Type": "application/json",
        ...options.headers,
    },
});
/**
 * List every feature flag defined in code with its stage, the permissions it brings, and who it is on for in this environment.
 *
 * **Allowed Permissions:** `feature-flags:read:global`
 */
export const getFeatureFlags = (options) => (options?.client ?? client).get({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/feature-flags",
    ...options,
});
/**
 * Set who a feature flag is on for: off, the given municipalities, or everyone. The municipalities are kept whatever the rollout. Municipalities that lose the flag lose its permissions from their roles.
 *
 * **Allowed Permissions:** `feature-flags:update:global`
 */
export const putFeatureFlagsByFlag = (options) => (options.client ?? client).put({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/feature-flags/{flag}",
    ...options,
    headers: {
        "Content-Type": "application/json",
        ...options.headers,
    },
});
/**
 * List every permission package defined in code, with the municipality permissions it brings.
 *
 * **Allowed Permissions:** `permissions:read:global`
 */
export const getPermissionPackages = (options) => (options?.client ?? client).get({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/permission-packages",
    ...options,
});
/**
 * List the permission packages a municipality has. Its own users can read them, as part of what its roles may be built from.
 *
 * **Allowed Permissions:** `permissions:read:global`, `permissions:read:municipality`
 */
export const getMunicipalitiesByMunicipalityIdPermissionPackages = (options) => (options.client ?? client).get({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/municipalities/{municipalityId}/permission-packages",
    ...options,
});
/**
 * Replace the permission packages a municipality has. A package left out also takes its permissions off the municipality’s roles, unless they have them another way.
 *
 * **Allowed Permissions:** `permissions:update:global`
 */
export const putMunicipalitiesByMunicipalityIdPermissionPackages = (options) => (options.client ?? client).put({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/municipalities/{municipalityId}/permission-packages",
    ...options,
    headers: {
        "Content-Type": "application/json",
        ...options.headers,
    },
});
/**
 * List the global roles with their permissions, paged, sorted and filtered.
 *
 * **Allowed Permissions:** `roles:read:global`
 */
export const getRoles = (options) => (options?.client ?? client).get({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/roles",
    ...options,
});
/**
 * Create a global role. It may only hold global permissions; giving it any needs `permissions:grant:global`, and only permissions you hold yourself.
 *
 * **Allowed Permissions:** `roles:create:global`
 */
export const postRoles = (options) => (options?.client ?? client).post({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/roles",
    ...options,
    headers: {
        "Content-Type": "application/json",
        ...options?.headers,
    },
});
/**
 * Delete a global role that no user holds. The Admin role cannot be deleted.
 *
 * **Allowed Permissions:** `roles:delete:global`
 */
export const deleteRolesByRoleId = (options) => (options.client ?? client).delete({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/roles/{roleId}",
    ...options,
});
/**
 * Get a global role with its permissions.
 *
 * **Allowed Permissions:** `roles:read:global`
 */
export const getRolesByRoleId = (options) => (options.client ?? client).get({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/roles/{roleId}",
    ...options,
});
/**
 * Rename a global role or replace its permissions (which needs `permissions:grant:global`). The Admin role is managed by the seed and cannot be changed here.
 *
 * **Allowed Permissions:** `roles:update:global`
 */
export const patchRolesByRoleId = (options) => (options.client ?? client).patch({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/roles/{roleId}",
    ...options,
    headers: {
        "Content-Type": "application/json",
        ...options.headers,
    },
});
/**
 * List a municipality's roles with their permissions, paged, sorted and filtered.
 *
 * **Allowed Permissions:** `roles:read:global`, `roles:read:municipality`
 */
export const getMunicipalitiesByMunicipalityIdRoles = (options) => (options.client ?? client).get({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/municipalities/{municipalityId}/roles",
    ...options,
});
/**
 * Create a role in a municipality. It may only hold permissions from the municipality's available set; giving it any needs `permissions:grant`, and only permissions you hold.
 *
 * **Allowed Permissions:** `roles:create:global`, `roles:create:municipality`
 */
export const postMunicipalitiesByMunicipalityIdRoles = (options) => (options.client ?? client).post({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/municipalities/{municipalityId}/roles",
    ...options,
    headers: {
        "Content-Type": "application/json",
        ...options.headers,
    },
});
/**
 * Delete a municipality's role that no user holds.
 *
 * **Allowed Permissions:** `roles:delete:global`, `roles:delete:municipality`
 */
export const deleteMunicipalitiesByMunicipalityIdRolesByRoleId = (options) => (options.client ?? client).delete({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/municipalities/{municipalityId}/roles/{roleId}",
    ...options,
});
/**
 * Get one of a municipality's roles with its permissions.
 *
 * **Allowed Permissions:** `roles:read:global`, `roles:read:municipality`
 */
export const getMunicipalitiesByMunicipalityIdRolesByRoleId = (options) => (options.client ?? client).get({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/municipalities/{municipalityId}/roles/{roleId}",
    ...options,
});
/**
 * Rename a municipality's role or replace its permissions (which needs `permissions:grant`), within the municipality's available set.
 *
 * **Allowed Permissions:** `roles:update:global`, `roles:update:municipality`
 */
export const patchMunicipalitiesByMunicipalityIdRolesByRoleId = (options) => (options.client ?? client).patch({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/municipalities/{municipalityId}/roles/{roleId}",
    ...options,
    headers: {
        "Content-Type": "application/json",
        ...options.headers,
    },
});
/**
 * List a municipality's users with their role, paged, sorted and filtered.
 *
 * **Allowed Permissions:** `users:read:global`, `users:read:municipality`
 */
export const getMunicipalitiesByMunicipalityIdUsers = (options) => (options.client ?? client).get({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/municipalities/{municipalityId}/users",
    ...options,
});
/**
 * Change a municipality user's role to another of the municipality's roles, one whose permissions you hold yourself, or deactivate them. You cannot change your own user.
 *
 * **Allowed Permissions:** `users:update:global`, `users:update:municipality`
 */
export const patchMunicipalitiesByMunicipalityIdUsersByUserId = (options) => (options.client ?? client).patch({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/municipalities/{municipalityId}/users/{userId}",
    ...options,
    headers: {
        "Content-Type": "application/json",
        ...options.headers,
    },
});
/**
 * List a municipality's invites with their status, paged, sorted and filtered.
 *
 * **Allowed Permissions:** `invites:read:global`, `invites:read:municipality`
 */
export const getMunicipalitiesByMunicipalityIdInvites = (options) => (options.client ?? client).get({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/municipalities/{municipalityId}/invites",
    ...options,
});
/**
 * Invite a coworker into the municipality with one of its roles. They get an email to set their password, and become a user when they do.
 *
 * **Allowed Permissions:** `invites:create:global`, `invites:create:municipality`
 */
export const postMunicipalitiesByMunicipalityIdInvites = (options) => (options.client ?? client).post({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/municipalities/{municipalityId}/invites",
    ...options,
    headers: {
        "Content-Type": "application/json",
        ...options.headers,
    },
});
/**
 * Email one of the municipality's pending or expired invites again.
 *
 * **Allowed Permissions:** `invites:update:global`, `invites:update:municipality`
 */
export const postMunicipalitiesByMunicipalityIdInvitesByInviteIdResend = (options) => (options.client ?? client).post({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/municipalities/{municipalityId}/invites/{inviteId}/resend",
    ...options,
});
/**
 * Revoke one of the municipality's pending or expired invites.
 *
 * **Allowed Permissions:** `invites:delete:global`, `invites:delete:municipality`
 */
export const postMunicipalitiesByMunicipalityIdInvitesByInviteIdRevoke = (options) => (options.client ?? client).post({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/municipalities/{municipalityId}/invites/{inviteId}/revoke",
    ...options,
});
/**
 * List every invite, global and municipality ones, with its status: pending, accepted, expired or revoked. Paged, sorted (newest first by default) and filtered by the query.
 *
 * **Allowed Permissions:** `invites:read:global`
 */
export const getInvites = (options) => (options?.client ?? client).get({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/invites",
    ...options,
});
/**
 * Invite someone and email them a link to set their password; they become a user when they do. A global invite (`municipalityId: null`) needs a global role, a municipality one the municipality's.
 *
 * **Allowed Permissions:** `invites:create:global`
 */
export const postInvites = (options) => (options?.client ?? client).post({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/invites",
    ...options,
    headers: {
        "Content-Type": "application/json",
        ...options?.headers,
    },
});
/**
 * Email a pending or expired invite again; its expiry starts over.
 *
 * **Allowed Permissions:** `invites:update:global`
 */
export const postInvitesByInviteIdResend = (options) => (options.client ?? client).post({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/invites/{inviteId}/resend",
    ...options,
});
/**
 * Revoke a pending or expired invite; links already sent stop working.
 *
 * **Allowed Permissions:** `invites:delete:global`
 */
export const postInvitesByInviteIdRevoke = (options) => (options.client ?? client).post({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/invites/{inviteId}/revoke",
    ...options,
});
/**
 * Change your own settings. A setting left out stays as it is; one never saved reads as its default.
 */
export const patchUsersMeSettings = (options) => (options?.client ?? client).patch({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/users/me/settings",
    ...options,
    headers: {
        "Content-Type": "application/json",
        ...options?.headers,
    },
});
/**
 * List the countries municipalities can be in, by name, with their settings. Also open to those who read, create or update municipalities, who see a municipality by its country and pick one from it.
 *
 * **Allowed Permissions:** `countries:read:global`, `municipalities:read:global`, `municipalities:create:global`, `municipalities:update:global`
 */
export const getCountries = (options) => (options?.client ?? client).get({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/countries",
    ...options,
});
/**
 * Add a country by its ISO 3166-1 alpha-2 code. `metricSrid` must be a projection in metres that PostGIS knows.
 *
 * **Allowed Permissions:** `countries:create:global`
 */
export const postCountries = (options) => (options?.client ?? client).post({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/countries",
    ...options,
    headers: {
        "Content-Type": "application/json",
        ...options?.headers,
    },
});
/**
 * Delete a country. Refused while any municipality is in it.
 *
 * **Allowed Permissions:** `countries:delete:global`
 */
export const deleteCountriesByCountryCode = (options) => (options.client ?? client).delete({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/countries/{countryCode}",
    ...options,
});
/**
 * Get a country and its settings.
 *
 * **Allowed Permissions:** `countries:read:global`
 */
export const getCountriesByCountryCode = (options) => (options.client ?? client).get({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/countries/{countryCode}",
    ...options,
});
/**
 * Replace a country's settings. Every municipality in it reads them on its next import.
 *
 * **Allowed Permissions:** `countries:update:global`
 */
export const putCountriesByCountryCode = (options) => (options.client ?? client).put({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/countries/{countryCode}",
    ...options,
    headers: {
        "Content-Type": "application/json",
        ...options.headers,
    },
});
/**
 * Get the adapters a new municipality in this country starts with, by kind and rank. The built-in adapters are not listed because they cannot be switched off.
 *
 * **Allowed Permissions:** `countries:read:global`
 */
export const getCountriesByCountryCodeDataSources = (options) => (options.client ?? client).get({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/countries/{countryCode}/data-sources",
    ...options,
});
/**
 * Replace a country's default adapters for one kind of data. The list is complete for that kind; the other kinds are left alone. Every row must name the kind in the path. Only municipalities created afterwards start with the new defaults.
 *
 * **Allowed Permissions:** `countries:update:global`
 */
export const putCountriesByCountryCodeDataSourcesByKind = (options) => (options.client ?? client).put({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/countries/{countryCode}/data-sources/{kind}",
    ...options,
    headers: {
        "Content-Type": "application/json",
        ...options.headers,
    },
});
